import React, { memo } from 'react';
import { styled } from '@nykaa/ui-components';
import { Wrapper, ImageItem } from './styles';

const Item = styled(ImageItem)`
  background: ${({ theme }) => theme.colors.surface20};
`;

function Placeholder() {
  return (
    <Wrapper>
      <Item />
      <Item />
      <Item />
      <Item />
      <Item />
      <Item />
      <Item />
      <Item />
      <Item />
    </Wrapper>
  );
}

export default memo(Placeholder);
